var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoLocationCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.35889C16.982 3.35889 21 7.37689 21 12.3589C21 17.3409 16.982 21.3589 12 21.3589",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.35889C16.982 3.35889 21 7.37689 21 12.3589C21 17.3409 16.982 21.3589 12 21.3589",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.3589C7.018 21.3589 3 17.3409 3 12.3589C3 7.37689 7.018 3.35889 12 3.35889",
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3589C7.018 21.3589 3 17.3409 3 12.3589C3 7.37689 7.018 3.35889 12 3.35889",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1675 4.41864C7.2775 9.24364 7.2775 15.4746 10.1675 20.2996C11.0135 21.7126 12.9865 21.7126 13.8325 20.2996C16.7225 15.4746 16.7225 9.24364 13.8325 4.41864C12.9855 3.00564 11.0135 3.00564 10.1675 4.41864Z",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00977 8.21631C8.90177 9.72731 15.0978 9.72731 19.9888 8.21631",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 16.4999C15.0987 14.9889 8.90272 14.9889 4.01172 16.4999",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoLocationCheck);
export default __webpack_public_path__ + "static/media/geo_location_check.19e9fd4b512a60d7c01068c13c30e5c6.svg";
export { ForwardRef as ReactComponent };